<ng-container *ngIf="points; else line">
  <div class="container">
    <div *ngFor="let step of [].constructor(numberOfSteps), let i = index" class="dot"
         [ngClass]="{'current': i === currentIndex, 'normal': i !== currentIndex}">
    </div>
  </div>
</ng-container>

  <ng-template #line>
    <div class="line"></div>
  </ng-template>
